import store from '../store';
import axios from 'axios';
import { Message } from 'element-ui';
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // 设置基本的 API URL
  timeout: 5000, // 设置请求超时时间
  headers: {
    'Content-Type': 'application/json',
  },
});

// 添加请求拦截器
instance.interceptors.request.use(
  config => {
    const token = store.state.token
    if (token) {
      config.headers.Authorization ='Bearer '+ token
    }
    return config;
  },
  error => {
    // 请求错误处理
    console.log('error',error);
  }
);

instance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    console.log('error',error);

    if (error.response.status === 401) {
      store.commit("SET_USER_LOGOUT");
      Message.error("登录过期,\n请重新登录");
      setTimeout(() => {
        location.reload()
      }, 500);
      return
    }
  }
);

export default instance;
